function fadeInImages() {
  const lazyImageContainers = [].slice.call(document.querySelectorAll(".fade-in-image"));
  const lazyImages = [].slice.call(document.querySelectorAll(".fade-in-image img"));

  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        const parent = entry.target.parentNode;
        if (entry.isIntersecting) {
          parent.classList.add("fade-in-image--loaded");
        } else {
          parent.classList.remove("fade-in-image--loaded");
        }
      });
    });

    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // Fallback if IntersectionObserver is not supported
    lazyImageContainers.forEach(function(container) {
      container.classList.add("fade-in-image--loaded");
    });
  }
}

function watchForResize() {
  const siteHeaderElement = document.getElementById('site-header');
  const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
      if (entry.target.id === 'site-header') {
        setCssVariables();
      }
    }
  });

  if (siteHeaderElement) resizeObserver.observe(siteHeaderElement);
}

function loadAnimations() {
  const animationContainers = [].slice.call(document.querySelectorAll(".animate"));

  if ("IntersectionObserver" in window) {
    let animationObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate--loaded");
        } else {
          entry.target.classList.remove("animate--loaded");
        }
      });
    });

    animationContainers.forEach(function(container) {
      animationObserver.observe(container);
    });
  } else {
    // Fallback if IntersectionObserver is not supported
    animationContainers.forEach(function(container) {
      container.classList.add("animate--loaded");
    });
  }
}

function initScrollReveals() {
  const revealElements = [].slice.call(document.querySelectorAll(".reveal-on-scroll, .reveal-stagger"));
  if (!revealElements.length) return;

  if ("IntersectionObserver" in window) {
    let revealObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: "0px 0px -8% 0px",
      threshold: 0.12
    });

    revealElements.forEach(function(element) {
      revealObserver.observe(element);
    });
  } else {
    revealElements.forEach(function(element) {
      element.classList.add("is-visible");
    });
  }
}

function setCssVariables() {
  const root = document.documentElement;
  const siteHeaderElement = document.getElementById('site-header');
  const siteFooterElement = document.getElementById('site-footer');

  if (siteHeaderElement) {
    const headerHeight = siteHeaderElement.offsetHeight;
    root.style.setProperty('--site-header-height', headerHeight + "px");
  }

  if (siteFooterElement) {
    const footerHeight = siteFooterElement.offsetHeight;
    root.style.setProperty('--site-footer-height', footerHeight + "px");
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function handleNewsletterSignup() {
  const liveUrl = window.location.href;
  const signUpResult = liveUrl.includes('form_type=customer');
  if (!signUpResult) return;

  const newsletterForms = document.querySelectorAll('.js-newsletter-form');

  newsletterForms.forEach((form) => {
    const inputValue = form.querySelector('.js-newsletter-form-input').value.length;

    if (inputValue != 0) {
      const messageContainer = document.createElement('div');

      messageContainer.innerText = window.newsletterStrings.alreadySubscribed;
      messageContainer.classList.add('form-message', 'space--pt--xsmall', 'flex', 'flex--align-center');
      form.appendChild(messageContainer);
    }
  });
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    if (event.currentTarget.closest('details').hasAttribute('open')) {
      event.currentTarget.setAttribute('aria-expanded', 'false');
    } else {
      event.currentTarget.setAttribute('aria-expanded', 'true');
    }
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('js-hosted-video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.changeEvent = new Event('change', { bubbles: true })
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".js-quantity-selector-button-minus");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".js-quantity-selector-button-plus");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class DrawerOpener extends HTMLElement {
  constructor() {
    super();

    this.drawerId = this.dataset.drawerId;
    this.drawerOpenButtons = document.querySelectorAll(`[data-drawer-to-open="${this.drawerId}"]`);
    this._onOpenButtonClick = this.onOpenButtonClick.bind(this);
    this._onCloseButtonClick = this.onCloseButtonClick.bind(this);
    this._onKeyUp = this.onKeyUp.bind(this);
    this.onBodyClickEvent = this.onBodyClick.bind(this);
    this.drawerOpenButtons.forEach((button) =>
      button.addEventListener('click', this._onOpenButtonClick)
    );
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeDrawer();
  }

  onOpenButtonClick(event) {
    const eventButton = event.currentTarget;
    const eventDrawerId = eventButton.dataset.drawerToToggle;

    event.preventDefault();
    this.openDrawer(eventDrawerId);
  }

  onCloseButtonClick(event) {
    const eventButton = event.currentTarget;
    const eventDrawerId = eventButton.dataset.drawerToToggle;

    event.preventDefault();
    this.closeDrawer(eventDrawerId);
  }

  openDrawer() {
    const targetDrawer = document.getElementById(this.drawerId);
    const drawerCloseButtons = document.querySelectorAll(`[data-drawer-to-close="${this.drawerId}"]`);

    if (!targetDrawer && this.drawerId === 'menu-drawer') {
      console.error(`The mobile menu is not found in the DOM. Make sure that the section within the "Header Group" is enabled in the theme editor.`);
    } else if (!targetDrawer) {
      console.error(`${this.drawerId} is not found in the DOM. Make sure that the section is enabled in the theme editor.`);
    }

    trapFocus(targetDrawer);
    document.body.addEventListener('click', this.onBodyClickEvent);
    this.addEventListener('keyup', this._onKeyUp);
    targetDrawer.removeAttribute('hidden');
    targetDrawer.setAttribute('open', true);
    setTimeout(() => {
      targetDrawer.classList.add('menu-opening');
      document.documentElement.classList.add('overlay-on');
    });
    this.drawerOpenButtons.forEach((button) => {
      button.setAttribute('aria-expanded', true);
      button.removeEventListener('click', this._onOpenButtonClick);
    });
    drawerCloseButtons.forEach((button) =>
      button.addEventListener('click', this._onCloseButtonClick)
    );
  }

  closeDrawer() {
    const targetDrawer = document.getElementById(this.drawerId);
    const drawerCloseButtons = document.querySelectorAll(`[data-drawer-to-close="${this.drawerId}"]`);

    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.documentElement.classList.remove('overlay-on');
    removeTrapFocus();
    this.removeEventListener('keyup', this._onKeyUp);
    targetDrawer.classList.remove('menu-opening');
    targetDrawer.addEventListener('transitionend', () => {
      targetDrawer.setAttribute('hidden', true);
    }, { once: true });
    drawerCloseButtons.forEach((button) =>
      button.removeEventListener('click', this._onCloseButtonClick)
    );
    this.drawerOpenButtons.forEach((button) => {
      button.addEventListener('click', this._onOpenButtonClick);
      button.setAttribute('aria-expanded', false);
    });
  }

  onBodyClick(event) {
    if (event.target.classList.contains('page-layout__overlay')) this.closeDrawer();
  }

  closeSubmenu(dialogElement) {
    dialogElement.classList.remove('menu-opening');
    dialogElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(dialogElement);
  }
}

customElements.define('drawer-opener', DrawerOpener);

class SimpleModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    this.setAttribute('open', '');
    this.removeAttribute('hidden');
  }

  hide() {
    this.removeAttribute('open');
    this.setAttribute('hidden', '');
    removeTrapFocus(this.openedBy);
  }
}
customElements.define('simple-modal-dialog', SimpleModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = document.getElementById(`Deferred-Poster-${this.dataset.mediaId}`);
    if (!poster) return;
    poster.addEventListener('click', (event) => this.loadContent(event));
  }

  loadContent(event, focus = true) {
    event.preventDefault();
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.slidesInView();
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.enableSliderLooping) return;

    const slideSpacingLeft = this.dataset.slideSpacingLeft || 0;

    if (!this.prevButton) return;
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft <= slideSpacingLeft) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  slidesInView() {
    let slidesInView = 0;

    this.sliderItemsToShow.forEach((element) => {
      if (this.isSlideVisible(element)) {
        return slidesInView++;
      }
    });

    return this.step = slidesInView;
  }

  onButtonClick(event) {
    event.preventDefault();

    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (this.step * this.sliderItemOffset) : this.slider.scrollLeft - (this.step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.productFormId = this.dataset.productFormId;
    this.productId = this.dataset.productId;

    // Prevent auto scroll on radio button selection
    this.querySelectorAll('input[type="radio"]').forEach((radioButton) => {
      radioButton.addEventListener('change', event => {
        // To get the scroll position of current webpage
        const TopScroll = window.scrollY || document.documentElement.scrollTop;
        const LeftScroll = window.scrollX || document.documentElement.scrollLeft;

        // if scroll happens, set it to the previous value
        window.onscroll = function() {
          window.scrollTo(LeftScroll, TopScroll)
        };

        // renable scroll after 0.5 second
        setTimeout(() => {
          window.onscroll = function() {};
        }, 500);
      });
    });
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    let selectedOptionValueIds = [];

    this.querySelectorAll('fieldset').forEach((selector) => {
      if (selector.querySelector('select')) {
        selectedOptionValueIds.push(selector.querySelector('select').selectedOptions[0].dataset.optionValueId);
      } else {
        selectedOptionValueIds.push(selector.querySelector('input[type="radio"]:checked').dataset.optionValueId);
      }
    });

    return selectedOptionValueIds;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductCardMediaGallery extends HTMLElement {
  constructor() {
    super();
    this.productCardContainer = this.closest('.product-card');
  }

  setActiveMedia(variantMediaId) {
    const variantMedia = this.querySelector(`[data-media-id="${variantMediaId}"]`);
    let selectedActiveMedia;
    if (variantMedia) {
      selectedActiveMedia = variantMedia;
    } else {
      selectedActiveMedia = this.querySelector(`[data-media-id="featured-image"]`);
    };

    this.querySelectorAll('[data-gallery-media-container]').forEach((media) => media.classList.remove('is-active'));

    selectedActiveMedia.classList.add('is-active');
  }
}

customElements.define('product-card-media-gallery', ProductCardMediaGallery);

class AnimatedDetails extends HTMLElement {
  constructor() {
    super();
    this.elementToggle = this.querySelector('[data-animated-details-toggle]');
    this.elementTarget = this.querySelector('[data-animated-details-target]');
    this.elementParent = this.closest('[data-animated-details-parent]');

    this.elementToggle.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.classList.contains('is-open')) {
        this.close();
      } else {
        this.open();
      }
    });

    this.elementToggle.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
  }

  open() {
    if (this.dataset.closeOtherAnimatedDetails === 'true') {
      document.querySelectorAll('animated-details[data-close-other-animated-details="true"]').forEach((element) => {
        element.close();
      });

      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      document.body.addEventListener('click', this.onBodyClickEvent);
    }

    this.onKeyupEvent =
      this.onKeyupEvent || this.onKeyup.bind(this);

    document.body.addEventListener('keyup', this.onKeyupEvent);

    this.classList.add('is-open');
    this.elementTarget.setAttribute('aria-hidden', false);
    this.elementToggle.setAttribute('aria-expanded', true);
  }

  close() {
    this.classList.remove('is-open');
    this.elementTarget.setAttribute('aria-hidden', true);
    this.elementToggle.setAttribute('aria-expanded', false);
    document.body.removeEventListener('keyup', this.onKeyupEvent);

    if (this.dataset.closeOtherAnimatedDetails === 'true') {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  onKeyupEvent(event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      document.querySelectorAll('animated-details').forEach((element) => {
        element.close();
      });
    };
  }
}

customElements.define('animated-details', AnimatedDetails);

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

// Swiper Functions
function initSwipers() {
  document.querySelectorAll('swiper-container').forEach((swiperContainer) => {
    swiperContainer.initialize();
    swiperContainer.classList.add('loaded');
    swiperContainer.parentElement.classList.add('swiper-loaded');
  });
}

window.addEventListener("load", fadeInImages);
window.addEventListener("load", loadAnimations);
window.addEventListener("load", initScrollReveals);
window.addEventListener("DOMContentLoaded", initScrollReveals);
window.addEventListener("load", setCssVariables);
window.addEventListener("load", initSwipers);
window.addEventListener("load", watchForResize);
window.addEventListener("load", handleNewsletterSignup);
document.addEventListener("shopify:section:load", initScrollReveals);
